module.exports = __webpack_public_path__ + "static/media/bmartlogo.58ed2596.png";